"use client";

import MicrosoftClarity from "@microsoft/clarity";

interface Props {
  customerId?: string;
}

export function Clarity({ customerId }: Props) {
  const projectId = process.env.NEXT_PUBLIC_CLARITY_PROJECT_ID;

  if (process.env.NODE_ENV === "production" && projectId) {
    MicrosoftClarity.init(projectId);
  }

  if (customerId) {
    MicrosoftClarity.identify(customerId);
  }

  return null;
}
